const AVATAR_PREFIX = 'fattahone_user_avatar_';

export function readUserAvatar(userUuid: string): string | null {
  try {
    return localStorage.getItem(`${AVATAR_PREFIX}${userUuid}`);
  } catch {
    return null;
  }
}

export function writeUserAvatar(userUuid: string, dataUrl: string) {
  localStorage.setItem(`${AVATAR_PREFIX}${userUuid}`, dataUrl);
  window.dispatchEvent(new CustomEvent('user-avatar-updated', { detail: { userUuid } }));
}

export function clearUserAvatar(userUuid: string) {
  localStorage.removeItem(`${AVATAR_PREFIX}${userUuid}`);
  window.dispatchEvent(new CustomEvent('user-avatar-updated', { detail: { userUuid } }));
}

/** Apply provider picture unless the user uploaded a custom photo (data URL). */
export function applyOAuthAvatar(userUuid: string, pictureUrl: string | null | undefined) {
  if (!pictureUrl?.trim()) return;
  const existing = readUserAvatar(userUuid);
  if (existing?.startsWith('data:')) return;
  writeUserAvatar(userUuid, pictureUrl.trim());
}

export function readImageFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
